/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  titleNejblizsi: {
    id: "b2b.rezervace.widget.title.nejblizsi",
    defaultMessage: "Next Reservation"
  },
  titleActionDownload: {
    id: "b2b.rezervace.widget.title-action.download",
    defaultMessage: "Full Timetable"
  }
});

export default () => useMessages(MESSAGES);
